// extracted by mini-css-extract-plugin
export default {"secondaryText":"tHTYaQ"};